export function extractRouteParamKeys(pathname: string): string[] {
  const keys: string[] = [];

  for (const segment of pathname.split('/')) {
    const match = segment.match(/^\[{1,2}(?:\.\.\.)?([^\]]+)\]{1,2}$/);
    if (match?.[1]) {
      keys.push(match[1]);
    }
  }

  return keys;
}
